<template>
  <ModuleBase
    :name="name"
    class="app-patch-note-banner"
    :desktopBackground="desktopBackground"
    :mobile-background="mobileBackground"
    :video-poster="desktopBackground"
  >
    <GfrContainer>
      <section class="app-patch-note-banner-content">
        <GfrTitle :level="2" class="app-patch-note-banner-title" :placement="placementComputed">
          {{ props.title }}
        </GfrTitle>
      </section>
    </GfrContainer>
  </ModuleBase>
</template>

<script lang="ts" setup>
import { ModuleBase } from '#components'
import { moduleBaseProps } from '@/components/module/base'
const props = defineProps({
  title: String,
  ...moduleBaseProps
})
const route = useRoute()
const placementComputed = computed(() => (route.params.lang === 'ar' ? 'right' : 'left'))
</script>
<style lang="scss" scoped>
.app-patch-note-banner {
  @apply h-100 max-lg:hidden lg:block;

  .com-container {
    @apply max-w-full;
  }
}

.app-patch-note-banner-content {
  @apply flex h-full w-1/2 items-center uppercase  drop-shadow-[0_0_12px_rgba(0,0,0,.5)]  lg:text-[48px]/[60px];
}
</style>
